<template>
  <div class="main">
    <van-nav-bar title="用户信息认证" />
    <div class="speepBox">
      <div class="list active">
        <div class="num">1</div>
        <p>上传身份证</p>
        <div class="line"></div>
      </div>
      <div class="list">
        <div class="num">2</div>
        <p>录制视频</p>
        <div class="line"></div>
      </div>
      <div class="list">
        <div class="num">3</div>
        <p>验证结果</p>
      </div>
    </div>
    <div class="imageGather">
      <div class="list">
        <!-- 第一张图片 -->
        <input type="file" style="display: none;" ref="fileOne" @change="getFile($event)" accept="image/jpeg,image/png,image/webp"
          capture="camera" />
        <img src="~assets/image/id.png" alt="">
        <van-icon class="upload-ok" v-show="fileName != ''" name="success" size="40px" color="#2c64d4" />
        <van-button round type="info" @click="$refs.fileOne.click()" size="normal"> 上传人像面 </van-button>
      </div>
      <!-- <div class="list">
        <input type="file" @change="getFile($event)" accept="image/*" capture="camera" />
        <img src="~assets/image/id.png" alt="">
        <van-icon class="upload-ok" name="success" size="40px" color="#2c64d4" />
        <van-button round type="info" size="small"> 上传国徽面 </van-button>
      </div> -->
      <!-- 信息展示 -->
      <div class="userInfo" v-show="userInfo.name != ''">
        <p class="info-title">请确认您的信息</p>
        <van-form ref="formInfo" @submit="onFailed" :submit-on-enter="false">
          <van-field v-model="userInfo.name" @change="changeFn" label="姓名"
            :rules="[{ validator: rulesName, message: '请输入正确姓名' }]" maxlength="6" />
          <van-field v-model="userInfo.id" @change="changeFn" label="身份证号"
            :rules="[{ validator: rulesId, message: '请输入正确证件号码' }]" maxlength="18" />
        </van-form>
      </div>
    </div>
    <div class="btnSubmit">
      <van-button round block type="info" @click="nextFn" :disabled="userInfo.name == ''">信息无误，下一步</van-button>
    </div>
    <van-overlay :show="showOverlay">
      <div class="wrapper" @click.stop>
        <van-loading color="#0094ff">识别中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { prepareSafeImage } from '@/utils/imageUpload';

export default {
  data() {
    return {
      active: 0,
      imageObj: {
        one: ''
      },
      fileName: '',
      userInfo: {
        name: '',
        id: ''
      },
      showOverlay: false
    }
  },
  mounted() {

  },
  methods: {
    rulesName(val) {
      let res = /^[\u4e00-\u9fa5]+$/;
      return res.test(val);
    },
    rulesId(val) {
      let res = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return res.test(val);
    },
    onFailed() {
      let data = JSON.parse(window.localStorage.getItem('userInfo'));
      if(data.name != this.userInfo.name) {
        this.$toast.fail('认证姓名与个人信息录入姓名不一致，请重新填写');
        return ;
      }
      this.$router.push('/rulestep/setp2')
    },
    async getFile(e) {
      const input = e.target;
      const file = input.files[0];
      if (!file) return;

      this.showOverlay = true;
      try {
        const safeImage = await prepareSafeImage(file);
        const res = await this.api.id_card_orc({ image: safeImage, filename: file.name });
        if (Number(res.code) !== 200) throw new Error(res.msg || '身份证识别失败');

        this.fileName = file.name;
        this.userInfo.name = res.data.name;
        this.userInfo.id = res.data.number;
        window.localStorage.setItem('user', JSON.stringify(this.userInfo));
      } catch (error) {
        this.fileName = '';
        this.$toast.fail(error.message || '图片校验失败，请重新上传');
      } finally {
        this.showOverlay = false;
        input.value = '';
      }
    },
    setImg(src) {
      this.imageObj.one = src
    },
    nextFn() {
      this.$refs.formInfo.submit()
    },
    changeFn() {
      window.localStorage.setItem('user', JSON.stringify(this.userInfo));
    },
    compressImgBySize(baseImg, maxSize = 800) {
      return new Promise((resolve) => {
        // 计算图片大小
        const strLength = baseImg.length
        const fileLength = parseInt(strLength - (strLength / 8) * 2)
        let size = parseInt((fileLength / 1024).toFixed(2))

        // 判断图片是否符合指定大小要求
        if (size <= maxSize) {
          resolve(baseImg)
          return
        }

        // 创建image对象
        const img = new Image()
        if (baseImg.indexOf('data:image/') !== -1) {
          img.src = baseImg
        } else {
          img.src = 'data:image/jpeg;base64,' + baseImg
        }

        img.onload = () => {
          // 把image对象 转换为 canvas对象
          const canvas = this.imgToCanvas(img)
          let resUrl = ''
          // 图片质量，范围：0 ~ 1
          let quality = 0.5

          // 当图片大小大于指定maxSize，图片质量大于0时继续通过降低图片资料来压缩
          while (size > maxSize && quality > 0) {
            console.log(maxSize, quality);
            // 在canvas上绘制该HTMLImageElement，得到图片base64
            resUrl = canvas.toDataURL('image/jpeg', quality).replace(/^data:image\/\w+;base64,/, '')
            const resLength = resUrl.length
            // 计算绘制出的base64图片大小
            const resFileLength = parseInt(resLength - (resLength / 8) * 2)
            size = parseInt((resFileLength / 1024).toFixed(2))
            // 降低图片质量
            quality = (quality - 0.1).toFixed(1)
          }
          resolve(resUrl)
        }
        img.onerror = () => {
          resolve(baseImg)
        }
      })
    },
    imgToCanvas(image) {
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      canvas.getContext('2d').drawImage(image, 0, 0)
      return canvas
    },

    getImgSize(str) {
      // 带上前缀时需去掉前缀
      str = str.replace('data:image/png;base64,', '');
      if (typeof (str) == 'string') {
        var strLength = str.length;
        var fileLength = parseInt(strLength - (strLength / 8) * 2);

        // 由字节转换为KB
        var size = "";
        size = (fileLength / 1024).toFixed(2);
        // 由字节转换为MB
        size = (fileLength / 1024 * 1024).toFixed(2);

        return parseInt(size);
      }
      return parseInt(0);
    }

  }
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.main {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
}

.imageGather {
  .list {
    width: 90%;
    height: 100px;
    border: 1px solid #e7e7e7;
    font-size: 14px;
    margin: 0 auto;
    margin-bottom: 14px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    position: relative;

    img {
      width: 120px;
      height: 60px;
      margin: 0px 40px 0px 12px;
    }

    .upload-ok {
      position: absolute;
      left: 55px;
      top: 20px;
    }
  }

  & /deep/ .van-button--small {
    padding: 0px 14px;
  }

  .userInfo {
    width: 95%;
    margin: 0 auto;
  }

  .info-title {
    padding-left: 16px;
  }

  .info-title {
    font-size: 16px;
    margin-top: 35px;
  }
}

.btnSubmit {
  width: 50%;
  margin: 0 auto;
  margin-top: 40px;
}
</style>
